import scrollPositionMixin from './scrollPositionMixin'

export default {
  data () {
    return {
      done: false
    }
  },
  mixins: [scrollPositionMixin],
  watch: {
    reached () {
      if (!this.done) {
        this.done = true
      }
    }
  },
  computed: {
    fadeClasses () {
      return {
        'is-fading-element': true,
        'is-fading-element-appear': this.done
      }
    }
  }
}
